import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { FamiliarSituations } from './components/FamiliarSituations';
import { ComparisonTable } from './components/ComparisonTable';
import { ProductIntro } from './components/ProductIntro';
import { TableOfContents } from './components/TableOfContents';
import { Testimonials } from './components/Testimonials';
import { ForYou } from './components/ForYou';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
import { Divider } from './components/Divider';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-brown" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Divider data-id="element-3" />

        <PainPoints data-id="element-4" />
        <FamiliarSituations data-id="element-5" />
        <Divider data-id="element-6" />

        <ComparisonTable data-id="element-7" />
        <ProductIntro data-id="element-8" />
        <Divider data-id="element-9" />

        <TableOfContents data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Divider data-id="element-12" />

        <ForYou data-id="element-13" />
        <Pricing data-id="element-14" />
        <Guarantee data-id="element-15" />

        <FinalClose data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
    </div>;
}